export const ROUTE_NAME_LOGIN = 'login';
export const ROUTE_NAME_DASHBOARD = 'dashboard';
export const ROUTE_NAME_FUND_OVERVIEW = 'fundOverview';
export const ROUTE_NAME_DEALS = 'deals';
export const ROUTE_LIQUIDITY = 'liquidity';
export const ROUTE_NAME_NOT_FOUND = 'notFound';
